/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type BulkUpdateBurnInRefresh_DisplayFragment = { __typename: 'Display', burnInRefreshSettings?: { __typename: 'BurnInRefreshSettingsState', reported: { __typename: 'BurnInRefreshSettings', time: string }, desired?: { __typename: 'BurnInRefreshSettings', time: string } | null } | null };

export type BulkUpdateBurnInRefreshMutationVariables = Types.Exact<{
  input: Types.DisplayBulkUpdateBurnInRefreshInput;
}>;


export type BulkUpdateBurnInRefreshMutation = { __typename: 'Mutation', displayBulkUpdateBurnInRefresh: { __typename: 'DisplayBulkUpdateBurnInRefreshPayload', displays: Array<{ __typename: 'Display', id: string, burnInRefreshSettings?: { __typename: 'BurnInRefreshSettingsState', reported: { __typename: 'BurnInRefreshSettings', time: string }, desired?: { __typename: 'BurnInRefreshSettings', time: string } | null } | null }> } };

export const BulkUpdateBurnInRefresh_DisplayFragmentDoc = gql`
    fragment BulkUpdateBurnInRefresh_display on Display {
  burnInRefreshSettings {
    reported {
      time
    }
    desired {
      time
    }
  }
}
    `;
export const BulkUpdateBurnInRefreshDocument = gql`
    mutation BulkUpdateBurnInRefresh($input: DisplayBulkUpdateBurnInRefreshInput!) {
  displayBulkUpdateBurnInRefresh(input: $input) {
    displays {
      id
      burnInRefreshSettings {
        reported {
          time
        }
        desired {
          time
        }
      }
    }
  }
}
    `;
export type BulkUpdateBurnInRefreshMutationFn = ApolloReactCommon.MutationFunction<BulkUpdateBurnInRefreshMutation, BulkUpdateBurnInRefreshMutationVariables>;

/**
 * __useBulkUpdateBurnInRefreshMutation__
 *
 * To run a mutation, you first call `useBulkUpdateBurnInRefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateBurnInRefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateBurnInRefreshMutation, { data, loading, error }] = useBulkUpdateBurnInRefreshMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateBurnInRefreshMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkUpdateBurnInRefreshMutation, BulkUpdateBurnInRefreshMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkUpdateBurnInRefreshMutation, BulkUpdateBurnInRefreshMutationVariables>(BulkUpdateBurnInRefreshDocument, options);
      }
export type BulkUpdateBurnInRefreshMutationHookResult = ReturnType<typeof useBulkUpdateBurnInRefreshMutation>;
export type BulkUpdateBurnInRefreshMutationResult = ApolloReactCommon.MutationResult<BulkUpdateBurnInRefreshMutation>;
export type BulkUpdateBurnInRefreshMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkUpdateBurnInRefreshMutation, BulkUpdateBurnInRefreshMutationVariables>;